/**
 * Optional reason a patient may attach to a self-service cancellation
 * (TM-9436 / #1334). Fixed set, no free text — a free-text field would risk
 * unstructured health-adjacent content. Skipping it never blocks the
 * cancellation. German labels live in the frontend; the stored values are
 * stable English codes.
 */
export var CancellationReason;
(function (CancellationReason) {
    /** Krankheit */
    CancellationReason["ILLNESS"] = "ILLNESS";
    /** Terminkonflikt */
    CancellationReason["SCHEDULE_CONFLICT"] = "SCHEDULE_CONFLICT";
    /** Abwesenheit */
    CancellationReason["ABSENCE"] = "ABSENCE";
    /** Sonstiges */
    CancellationReason["OTHER"] = "OTHER";
})(CancellationReason || (CancellationReason = {}));
//# sourceMappingURL=cancellation-reason.enum.js.map